"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import IndustryAgentPage from "./IndustryAgentPage";
import { retailIndustry } from "@/content/industries/retail";

export default function IndustryRetail({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <IndustryAgentPage page={retailIndustry} locale={locale} />;
}
